import React from 'react';

interface AnnouncementIconProps {
  size?: number;
  color?: string;
}

const AnnouncementIcon: React.FC<AnnouncementIconProps> = ({
  size = 17,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.95686 4.07803C8.23183 3.91952 8.58329 4.01406 8.74201 4.28897L12.8612 11.4237C13.0198 11.6987 12.926 12.05 12.6512 12.2089C12.3762 12.3677 12.0239 12.2738 11.8651 11.9989L7.74592 4.86319C7.5874 4.58822 7.68195 4.23675 7.95686 4.07803Z"
      fill={color}
    />
    <path
      d="M8.04174 4.5597C8.25856 4.32777 8.62226 4.31564 8.85424 4.53235C9.08622 4.74922 9.09846 5.11288 8.88159 5.34485L2.05248 12.6486L2.27709 13.0372L12.0173 10.7765C12.3267 10.7047 12.6359 10.8968 12.7078 11.2062C12.7796 11.5154 12.5873 11.8247 12.2781 11.8966L2.1228 14.254C1.87631 14.3112 1.62138 14.2007 1.49487 13.9816L0.844477 12.8546C0.71819 12.6355 0.749867 12.3597 0.922602 12.1749L8.04174 4.5597Z"
      fill={color}
    />
    <path
      d="M7.00567 11.9663C7.28066 11.8074 7.632 11.9022 7.79082 12.1772L7.87969 12.3295L7.97539 12.5131C8.17574 12.9509 8.21905 13.4401 8.09551 13.9165C7.95434 14.4532 7.60616 14.9122 7.12676 15.1918C6.64731 15.4716 6.07647 15.5487 5.53985 15.4077C5.0031 15.2665 4.54415 14.9183 4.26446 14.4389L4.26348 14.437L3.70391 13.4682C3.54512 13.1932 3.63983 12.8418 3.91485 12.6831C4.18983 12.5244 4.54123 12.6181 4.7 12.893L5.25664 13.8588C5.38261 14.0748 5.59016 14.2327 5.83184 14.2963C6.07362 14.3599 6.33088 14.3245 6.54668 14.1987C6.76242 14.0729 6.91952 13.8661 6.98321 13.6245C7.0468 13.3827 7.01254 13.1246 6.88653 12.9086L6.88457 12.9067L6.79571 12.7514C6.63706 12.4765 6.73075 12.125 7.00567 11.9663Z"
      fill={color}
    />
    <path
      d="M7.9489 2.53696V1.19809C7.9489 0.880526 8.20653 0.622894 8.5241 0.622894C8.84166 0.622894 9.09929 0.880526 9.09929 1.19809V2.53696C9.09912 2.85437 8.84155 3.11118 8.5241 3.11118C8.20664 3.11118 7.94908 2.85437 7.9489 2.53696Z"
      fill={color}
    />
    <path
      d="M14.9914 7.09C15.3088 7.09017 15.5656 7.34774 15.5656 7.6652C15.5656 7.98266 15.3088 8.24023 14.9914 8.24039H13.6525C13.3349 8.24039 13.0773 7.98276 13.0773 7.6652C13.0773 7.34763 13.3349 7.09 13.6525 7.09H14.9914Z"
      fill={color}
    />
    <path
      d="M3.39683 7.09C3.71425 7.09018 3.97105 7.34774 3.97105 7.6652C3.97105 7.98265 3.71425 8.24021 3.39683 8.24039H2.05797C1.7404 8.24039 1.48277 7.98276 1.48277 7.6652C1.48277 7.34763 1.7404 7.09 2.05797 7.09H3.39683Z"
      fill={color}
    />
    <path
      d="M3.5444 2.68601C3.76895 2.46146 4.13235 2.46146 4.3569 2.68601L5.30416 3.6323C5.52843 3.85687 5.52862 4.22132 5.30416 4.44577C5.07971 4.67023 4.71526 4.67004 4.49069 4.44577L3.5444 3.49851C3.31985 3.27396 3.31985 2.91056 3.5444 2.68601Z"
      fill={color}
    />
    <path
      d="M12.6906 2.68588C12.9151 2.46135 13.2785 2.4614 13.5031 2.68588C13.7275 2.91029 13.7282 3.27379 13.5041 3.49838L12.5568 4.44565C12.3324 4.66968 11.9688 4.66969 11.7443 4.44565C11.5198 4.2211 11.5198 3.85673 11.7443 3.63217L12.6906 2.68588Z"
      fill={color}
    />
  </svg>
);

export default AnnouncementIcon;
